import { render, staticRenderFns } from "./CouponCenter.vue?vue&type=template&id=1a4ff614&scoped=true&"
import script from "./CouponCenter.vue?vue&type=script&lang=ts&"
export * from "./CouponCenter.vue?vue&type=script&lang=ts&"
import style0 from "./CouponCenter.vue?vue&type=style&index=0&id=1a4ff614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4ff614",
  null
  
)

export default component.exports